import React, { Suspense } from 'react';
import Spinner from '../../components/spinner';

// Lazy-loaded components
const EventsPagePageSession = React.lazy(() => import('../events/EventsPageSession'));
const EventsPageHeader = React.lazy(() => import('../events/EventsPageHeader'));

function EventsPage() {
  return (
    <div className="page-wrapper">
   
      {/* Suspense to handle lazy loading */}
      <Suspense fallback={<Spinner />} jsx={true.toString()}>
       <EventsPageHeader />
       <EventsPagePageSession />
      </Suspense>
    </div>
  );
}

export default EventsPage;
